<template>
  <div class="app-wrapper">
    <navbar />
    <div style="display: flex"
      :class="{ bgColor1: isColor1, bgColor2: isColor2, bgColor3: isColor3, bgColoor4: isColor4 }">
      <chuang v-if="path == '/home'" />
      <app-main />
      <chuang-r v-if="path == '/home'" />
    </div>
    <Footer />
  </div>
</template>
<script>
import { Navbar, AppMain, Chuang, ChuangR, Footer } from './components'
export default {
  name: 'Layout',
  components: {
    Navbar,
    AppMain,
    Chuang,
    ChuangR,
    Footer,
  },
  watch: {
    $route (to, from) {
      this.path = to.path
      this.changeColor(to.path)
    },
  },
  data () {
    return {
      path: '',
      isColor1: false,
      isColor2: false,
      isColor3: false,
      isColor4: false,
    }
  },
  mounted () {
    var _this = this
    _this.path = _this.$route.path
    _this.changeColor(_this.path)
  },
  methods: {
    changeColor (path) {
      this.isColor1 = false
      this.isColor2 = false
      this.isColor3 = false
      if (path == '/home') {
        this.isColor1 = true
      } else if (path == '/ztjy') {
        this.isColor3 = true
      } else if (path == '/fj20z') {
        this.isColor4 = true
      } else {
        this.isColor2 = true
        this.isColor4 = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.bgColor1 {
  background: #f7f7f7;
}

.bgColor2 {
  background-color: '';
}

.bgColor3 {
  background: #ebf8ff;
}

.bgColor4 {
  background: #E7F9FF;
}
</style>
